'use client';

import { useTranslation } from 'next-i18next';

/**
 * @description Offer Page Job Subtitle
 */
export const OfferPageJobSubtitle = () => {
  const { t } = useTranslation('common');

  return (
    <div>
      <h3 className="relative mb-10 text-left text-xl font-bold">{t('offer.page.job-section-title')}</h3>
    </div>
  );
};
